import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { PopupForm } from "./components/PopupForm";
import { Home } from "./pages/Home";
import { About } from "./pages/About";
import { Contact } from "./pages/Contact";
import { TrademarkRegistration } from "./pages/TrademarkRegistration";
import { CopyrightRegistration } from "./pages/CopyrightRegistration";
import { TrademarkSearch } from "./pages/TrademarkSearch";
import { CompanyFormation } from "./pages/CompanyFormation";
import { AmazonBrandRegistry } from "./pages/AmazonBrandRegistry";
import { PrivacyPolicy } from "./pages/PrivacyPolicy";
import { TermsOfService } from "./pages/TermsOfService";
import { LandingPage } from "./pages/LandingPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <div className="App">
      <BrowserRouter>
        <Header onOpenPopup={() => setIsPopupOpen(true)} />
        <main style={{ flex: '1 0 auto' }}>
          <Routes>
            <Route path="/" element={<Home onOpenPopup={() => setIsPopupOpen(true)} />} />
            <Route path="/about" element={<About onOpenPopup={() => setIsPopupOpen(true)} />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/services/trademark-registration" element={<TrademarkRegistration onOpenPopup={() => setIsPopupOpen(true)} />} />
            <Route path="/services/copyright-registration" element={<CopyrightRegistration onOpenPopup={() => setIsPopupOpen(true)} />} />
            <Route path="/services/trademark-search" element={<TrademarkSearch onOpenPopup={() => setIsPopupOpen(true)} />} />
            <Route path="/services/company-formation" element={<CompanyFormation onOpenPopup={() => setIsPopupOpen(true)} />} />
            <Route path="/services/amazon-brand-registry" element={<AmazonBrandRegistry onOpenPopup={() => setIsPopupOpen(true)} />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/lp" element={<LandingPage />} />
          </Routes>
        </main>
        <Footer />
        <PopupForm isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
